function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon-blik_svg__a",
  x1: -927.27,
  y1: 544.43,
  x2: -926.4,
  y2: 543.55,
  gradientTransform: "scale(14.18 -14.18) rotate(89.63 -186.799 737.933)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e52f08"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e94f96"
})));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.19,
  cy: 43.39,
  r: 8.8,
  fill: "url(#icon-blik_svg__a)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M50.91 37.41h9.84v55.84h-9.84V37.41zM69.49 56.67h9.84v36.58h-9.84V56.67zM25.32 56.31c-3.08 0-6.12.76-8.83 2.22V37.41H6.65v37.57c0 10.31 8.35 18.67 18.66 18.67s18.67-8.35 18.67-18.66-8.35-18.67-18.66-18.67zm0 27.65a8.98 8.98 0 01-8.98-8.98A8.98 8.98 0 0125.32 66a8.98 8.98 0 018.98 8.98c0 4.96-4.02 8.98-8.98 8.99zM111.7 93.25h12.68l-15.23-19.67 13.81-16.9h-11.5L97.9 73.69V37.42h-9.84v55.84h9.84V73.74l13.8 19.52z"
});

function SvgIconBlik(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full"
  }, props), _ref, _ref2, _ref3);
}

export default SvgIconBlik;